import React, { lazy } from "react";
import { Component } from "react";
import { motion } from "framer-motion";
import "./header.scss";
import Navbar from "./navigation-bar/navbar";
import mapImage from "../../assets/images/map.svg";
import { slide as Menu } from "react-burger-menu";
import { isMobile } from "react-device-detect";
import closeIcon from "../../assets/images/close-icon.svg";
import burgerIcon from "../../assets/images/menu-icon.svg";
import MenuLinks from "../MenuLinks";
const ContactUsPage = lazy(() => import("./contact-us-page/ContactusPage"));
const animation = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 1,
    },
  },
};

export default class Header extends Component {
  state = {
    isOpen: false,
    timesRendered: 0,
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
      timesRendered: this.state.timesRendered + 1,
    });
  };

  reactToToggles = () => {
    if (this.state.isOpen) {
      return (
        <div id={"compact-menu"}>
          <a href={"https://www.roshan-ai.ir/"} id={"mobile-menu-link"}>
            صفحهٔ اصلی
          </a>
          <a href={"https://www.roshan-ai.ir/about-us"} id={"mobile-menu-link"}>
            دربارهٔ ما
          </a>
          <a href={"https://www.roshan-ai.ir/about-us"} id={"mobile-menu-link"}>
            تماس با ما
          </a>
          <a href={"https://www.roshan-ai.ir/about-us"} id={"mobile-menu-link"}>
            همکاری با ما
          </a>
        </div>
      );
    } else {
      return <ContactUsPage shouldRerender={this.state.timesRendered === 0} />;
    }
  };

  render() {
    return (
      <motion.div
        variants={animation}
        initial='hidden'
        animate='visible'
        id={"all"}>
        <Menu
          menuClassName={"menu"}
          itemListElement='div'
          burgerButtonClassName={"my-button"}
          pageWrapId={"header-wrapper"}
          itemListClassName={"menu-items"}
          crossButtonClassName={"my-cross"}
          outerContainerId={"all"}
          customBurgerIcon={<img src={burgerIcon} alt={""} />}
          customCrossIcon={
            <div>
              <img src={closeIcon} alt={""} />
            </div>
          }>
          <MenuLinks />
        </Menu>
        <div className='header-wrapper' id={"header-wrapper"}>
          <Navbar toggle={this.toggle} isOpen={this.state.isOpen} />
          <img
            src={mapImage}
            className={this.state.isOpen ? "hidden-image" : ""}
            id={"map-image"}
            alt={""}
          />
          <a
            id={"navigation-button"}
            href={
              isMobile
                ? "geo:35.7113,51.4105;u=35"
                : "https://goo.gl/maps/ms3rUPvSMtsscEXr9"
            }>
            <span>مسیریابی</span>
            <span>
              &#10095;
              {/* <svg width="6" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1 1 5l4 4" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> */}
            </span>
          </a>
          {this.reactToToggles()}
        </div>
      </motion.div>
    );
  }
}
